import { appWithTranslation, useTranslation } from "next-i18next";
import { Nav } from "@/features/nav";
import "./tailwind-dist.css";
import "./_app.css";
import { useState } from "react";
import { Footer } from "@/features/footer";
import FirebaseConfig from "@/config/FirebaseConfig";
import { isDevelopMode } from "@/utils/WebUtils";
import { Config } from "@/config/Config";
import { ConfigContextProvider } from "@/context/ConfigContext";
import { I18NContextProvider } from "@/context/I18NContext";
import { IoBookOutline, IoExitOutline } from "react-icons/io5";
import { PageHead as Head } from "@/components/pageHead";
import { AuthContextProvider } from "@/context/AuthContext";
import {
  FirebaseModule,
  getAuth,
  getFirebaseClient,
} from "@/utils/FirebaseUtils";
import Image from "next/image";

const SCROLL_TOP_OFFSET = 10;

function MyApp({ Component, pageProps, router, locale }: any) {
  const [scrolled, setScrolled] = useState(false);
  const staticNav = router.route != "/";

  if (typeof window != "undefined") {
    getFirebaseClient(FirebaseConfig, [FirebaseModule.ANALYTICS]).then(
      (firebase: any) => {
        const analytics = firebase.analytics.getAnalytics();

        if (pageProps.metadata && !isDevelopMode()) {
          firebase.analytics.logEvent(analytics, "page_view", {
            page_title: pageProps.metadata.title,
            page_path: router.pathname,
          });
        }
      }
    );
  }

  const { t } = useTranslation();

  return (
    <ConfigContextProvider
      config={{
        firebase: FirebaseConfig,
        ...Config,
      }}
    >
      <I18NContextProvider t={t}>
        <AuthContextProvider>
          {pageProps.metadata && (
            <Head
              metadata={{
                ...pageProps.metadata,
                path: router.asPath,
                language: t("language"),
              }}
            />
          )}
          <Nav
            scrolled={staticNav || scrolled}
            showLogin={false}
            logo={
              <Image
                src={"/logo_small.webp"}
                style={{
                  objectFit: "contain",
                  objectPosition: "left",
                  height: 45
                }}
                width={200}
                height={45}
                alt="Logo"
              />
            }
            showLoginLoading={true}
            userActions={[
              {
                label: "Blog",
                url: "/blog",
                icon: <IoBookOutline />,
              },
              {
                label: "Cerrar sesión",
                action: () => {
                  getFirebaseClient(FirebaseConfig, [FirebaseModule.AUTH]).then(
                    (firebase: any) => {
                      const { auth, signOut } = getAuth(firebase);
                      signOut(auth);
                    }
                  );
                },
                icon: <IoExitOutline />,
              },
            ]}
          />
          <main
            style={{
              paddingTop: staticNav ? 64 : 0,
            }}
            onScroll={(e: any) => {
              if (
                e.target.scrollTop > SCROLL_TOP_OFFSET &&
                !scrolled &&
                !staticNav
              ) {
                setScrolled(true);
              }

              if (
                e.target.scrollTop < SCROLL_TOP_OFFSET &&
                scrolled &&
                !staticNav
              ) {
                setScrolled(false);
              }
            }}
          >
            <Component {...pageProps} />
            <Footer />
          </main>
        </AuthContextProvider>
      </I18NContextProvider>
    </ConfigContextProvider>
  );
}

export default appWithTranslation(MyApp);
